import { Conclave } from './conclave';

export const NUMBER_OF_REQUIRED_CONCLAVES = 2;

export const REQUIRED_CONCLAVES: Conclave[] = [
  { name: 'Early Harvest' },
  { name: 'Eternal Dawn' },
  { name: 'Homeland' },
  { name: 'Mythic Beasts' },
  { name: 'Nature\'s Vitality' },
  { name: 'Nesting Peaks' },
  { name: 'Open the Gateway' },
  { name: 'Staying Power' },
  { name: 'Taming the Wild' }
];

export const EXTRA_CONCLAVES: Conclave[] = [
  { name: 'Riding the Brink' },
  { name: 'Secret Sanctuaries' },
  { name: 'Seeds of Bounty' },
  { name: 'Seekers of the Sun' },
  { name: 'Upwelling' }
];
